import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-grid-system';
import * as LocalizationUtil from '@vp-dst/localization-util';

import ScreenSizeUtil from 'utils/ScreenSizeUtil';
import Typography from 'components/vistaprintUILibrary/Typography';

import withScreenClass from 'components/highOrder/withScreenClass';
import SectionHeading from 'components/SectionHeading';

function DesignerSpotlight(props) {
  const {
    name,
    quote,
    highlights,
    workSampleImageSrc,
    profileImageSrc,
    screenClass,
  } = props;

  const isSmallScreen = ScreenSizeUtil.isSmallScreen(screenClass);

  return (
    <Row
      style={{
        marginBottom: 20,
      }}
    >
      <Col xs={12} md={6}>
        <div
          style={{
            height: isSmallScreen ? 300 : 460,
            width: '100%',

            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',

            overflow: 'visible',
          }}
        >
          <img
            style={{
              height: '100%',
            }}
            src={workSampleImageSrc}
            alt={LocalizationUtil.getLocalizedText('designer-spotlight')}
          />
        </div>
      </Col>
      <Col xs={12} md={6}>
        <Row>
          <Col xs={12}>
            <SectionHeading
              text={LocalizationUtil.getLocalizedText('designer-spotlight')}
              alignment={isSmallScreen ? 'center' : 'left'}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={4}>
            <div
              style={{
                display: 'flex',
                justifyContent: isSmallScreen ? 'center' : 'flex-end',
              }}
            >
              <img
                src={profileImageSrc}
                alt={name}
                style={{
                  height: isSmallScreen ? 125 : 125,
                  width: isSmallScreen ? 125 : 125,
                }}
              />
            </div>
          </Col>
          <Col xs={12} md={8}>
            <div
              style={{
                display: 'flex',
                justifyContent: isSmallScreen ? 'center' : 'flex-start',
                marginBottom: 15,
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'flex-start',
                }}
              >
                <Typography
                  variant="heading2"
                  text={name}
                  style={{
                    marginBottom: 20,
                    alignSelf: isSmallScreen ? 'center' : 'flex-start',
                  }}
                />
                {highlights.map(highlight => (
                  <div
                    key={`designer-highlight-${highlight.text.replace(' ', '')}`}
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      marginBottom: 15,
                    }}
                  >
                    <img
                      src={highlight.iconSrc}
                      alt={highlight.text}
                      style={{
                        boxSizing: 'border-box',
                        marginRight: 10,
                        width: 20,
                        maxHeight: 20,
                      }}
                    />
                    <Typography
                      text={highlight.text}
                      style={{
                        paddingTop: 4, // help align with the icon
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div
              style={{
                textAlign: isSmallScreen ? 'center' : 'left',
              }}
            >
              <Typography
                variant="quote"
                text={`"${quote}"`}
                style={{
                  fontSize: '1.2em',
                }}
              />
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

DesignerSpotlight.propTypes = {
  name: PropTypes.string.isRequired,
  workSampleImageSrc: PropTypes.string.isRequired,
  profileImageSrc: PropTypes.string.isRequired,
  highlights: PropTypes.arrayOf(PropTypes.shape({
    iconSrc: PropTypes.string,
    text: PropTypes.string,
  })).isRequired,
  quote: PropTypes.string.isRequired,
  screenClass: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']).isRequired,
};

export default withScreenClass(DesignerSpotlight);



// WEBPACK FOOTER //
// ./src/components/DesignerSpotlight.js